import { makeAutoObservable } from 'mobx';

import { ImageDto, ServiceDto } from '../dto';

export class VenueServiceModel {
  private _title: string;
  private _description: string;
  private _image: ImageDto;
  private _active: boolean;
  private _pk: number;
  private _used: boolean;
  constructor(res: ServiceDto & { used: boolean }) {
    this._title = res.title;
    this._description = res.description;
    this._image = res.image;
    this._active = res.active || false;
    this._pk = res.pk || -1;
    this._used = res.used || false;
    makeAutoObservable(this);
  }
  get title() {
    return this._title || '';
  }
  get description() {
    return this._description || '';
  }
  get image() {
    return this._image || null;
  }
  get active() {
    return this._active || false;
  }
  get pk() {
    return this._pk || -1;
  }
  get used() {
    return this._used || false;
  }
}
